'use client';

import { NativeSelect as Select } from '@chakra-ui/react';
import * as React from 'react';

interface NativeSelectRootProps extends Select.RootProps {
	icon?: React.ReactNode
}

export const NativeSelectRoot = React.forwardRef<HTMLDivElement, NativeSelectRootProps>(function NativeSelect(props, ref) {
	const { children, icon, ...rest } = props;

	return (
		<Select.Root ref={ref} {...rest}>
			{children}
			<Select.Indicator>
				{icon}
			</Select.Indicator>
		</Select.Root>
	);
});

interface NativeSelectFieldProps extends Select.FieldProps {
	items?: Array<NativeSelectItem | string>
}

interface NativeSelectItem {
	disabled?: boolean
	label:     string
	value:     string
}

export const NativeSelectField = React.forwardRef<HTMLSelectElement, NativeSelectFieldProps>(function NativeSelectField(props, ref) {
	const { children, items: itemsProp, ...rest } = props;

	const items = React.useMemo(
		() =>
			itemsProp?.map(item =>
				(typeof item === 'string'
					? {
							label: item,
							value: item,
						}
					: item)),
		[ itemsProp ],
	);

	return (
		<Select.Field ref={ref} {...rest}>
			{children}
			{items?.map(item => (
				<option disabled={item.disabled} key={item.value} value={item.value}>
					{item.label}
				</option>
			))}
		</Select.Field>
	);
});
